<template>
    <div :class="pageType">
        <div v-if="isLoading" class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <right-side-content v-if="!isLoading"
                            :product="product"
                            :page-type="pageType"
                            :specifications="courseSpecificationsByDate"
                            :specification-programs="specificationPrograms"
                            :specification-dates="specificationDates"
                            :product-combination="productCombination"
                            :favorite-added="favoriteAdded"
                            :favorite-added-data="favoriteAddedData"
                            :auth-check="authCheck"
                            :csrf="csrf"
                            :already-buy="alreadyBuy"
                            :spec-status ="specStatus"
                            :rating-score="ratingScore"
                            :rating-count="ratingCount"
        >
        </right-side-content>
    </div>
</template>
<script>

import RightSideContent from 'Vue/Web/Shop/Course/RightSideContent.vue';
export default {
    name: 'RightSideSalesComponent',
    components: {
        RightSideContent,
    },
    props: {
        authId: {
            type: Number,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: -1,
        },
        pageType: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: 'course',
        },
        product: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: () => {},
        },
        authCheck: {
            type: Boolean,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: false,
        },
        csrf: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '',
        },
        favoriteAddedData: {
            type: Boolean,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: false,
        },
        urlHash: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '',
        },
    },
    data() {
        return {
            isLoading: true,
            url: '/api/courseSalesAbleSpec',
            id: 0,
            courseSpecificationsByDate: [],
            specificationPrograms: [],
            specificationDates: [],
            productCombination: {},
            specStatus: 1,
            ratingScore: '',
            ratingCount: 0,
            alreadyBuy: false,
            favoriteAdded: false,
        };
    },
    computed: {
    },
    mounted() {
    },
    created() {
        switch (this.pageType) {
            case 'course':
                this.url = '/api/courseSalesAbleSpec';
                break;
            case 'product':
                this.url = '/api/productSalesAbleSpec';
                break;
            default:
                this.url = '/api/courseSalesAbleSpec';
                break;
        }
        this.id = this.product.id;
        this.favoriteAdded = this.product.favoriteAdded;
        this.getResult();
    },
    methods: {
        async getResult() {

            try {
                const vueThis = this;
                await axios.get(`${this.url}/${this.id}/${this.urlHash}`)
                    .then((response) => {
                        vueThis.isLoading = false;
                        const {data} = response;
                        vueThis.specStatus = data.specStatus;
                        vueThis.alreadyBuy = data.alreadyBuy;
                        vueThis.ratingScore = data.ratingScore;
                        vueThis.ratingCount = data.ratingCount;
                        // eslint-disable-next-line max-len
                        vueThis.productCombination = data?.productCombination ?? {};

                        vueThis.courseSpecificationsByDate = data.courseSpecificationsByDate;

                        vueThis.courseSpecificationsByDate.forEach((specifications) => {
                            const courseDate = specifications[0].courseDate;
                            const specificationDatesId = specifications[0].specificationDatesId;
                            const specificationPrograms = [];

                            specifications.forEach((specification) => {
                                specificationPrograms.push({
                                    programName: specification.programName,
                                    specificationPlanId: specification.specificationPlanId,
                                    baseNumber: specification.baseNumber,
                                    specification,
                                    prioritynum: specification?.specificationPlan?.prioritynum,
                                });
                            });

                            specificationPrograms.sort((a, b) => b.prioritynum - a.prioritynum);

                            vueThis.specificationDates.push({
                                courseDate,
                                specificationDatesId,
                                specificationPrograms,
                            });
                        });
                    });

                // 等待 DOM 完全更新後再初始化 OwlCarousel
                this.$nextTick(() => {
                    // this.initOwlCarousel();
                });
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>
<style scoped lang="scss">
$maincolor: #72ca4a;
.spinner-border {
    margin: 50%;
}
.product{
    width: 50%;
    @media (max-width: 1024px) {
        width: 100%;
    }
}
</style>
